import React from 'react'

import { FullRequestAir } from 'src/types'

import { WrapCard } from '../../../../../styles'

import List from './list'

export type PickFareProps = {
  selectedFares: FullRequestAir[]
  onPickFare(fare: FullRequestAir, searchKey: string): void
}

function SearchResultCard() {
  return (
    <WrapCard data-test-id="air-result-card">
      <List />
    </WrapCard>
  )
}

export default SearchResultCard
